if (typeof screen !== 'undefined' && !screen.orientation) {
    const orientation = new EventTarget() as ScreenOrientation
    Object.defineProperty(orientation, 'type', {
        get: () => (window.matchMedia('(orientation: landscape)').matches ? 'landscape-primary' : 'portrait-primary'),
    })
    Object.defineProperty(screen, 'orientation', { value: orientation })
}
